import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HelpersModule } from '@core/components/helpers/helpers.module';
import { LayoutTitlesModule } from '@core/components/layout/titles/titles.module';

import { LogbookSearchMainComponent } from './main/main.component';
import { AppHelpersSearchFiltersModule } from 'app/components/helpers/search/filters/filters.module';
import { AppHelpersSearchBarModule } from 'app/components/helpers/search/bar/bar.module';
import { ProjectsLogbookSearchFiltersComponent } from './filters/filters.component';

@NgModule({
    imports: [
        CommonModule,
        HelpersModule,
        LayoutTitlesModule,
        AppHelpersSearchFiltersModule,
        AppHelpersSearchBarModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        LogbookSearchMainComponent,
        ProjectsLogbookSearchFiltersComponent
    ],
    exports: [
        LogbookSearchMainComponent
    ],

})
export class ProjectsLogbookSearchModule{ }
